<template>
  <div class="video-icon-shade">
    <i class="el-icon-video-play video-icon" :style="{'font-size': size + 'px'}"></i>
  </div>
</template>

<script>
    export default {
        name: "VideoShadeIcon",
        props: {
            /**
             * 图标大小
             */
            size: {
                type: Number,
                default: 35
            }
        }
    }
</script>

<style scoped>
  .video-icon-shade {
    position: absolute;
    background-image: linear-gradient(to bottom, transparent, rgba(0, 0, 0, .6));
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .video-icon-shade .video-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-weight: bold;
    color: #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/view/component/VideoShadeIcon.vue